import moment from "moment";

import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import * as SubServerOperations from "@/Common/Operations/operations.server.sub";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { PatientTaskListItem } from "@/Patient/Models/History/PatientTaskListItem";
import { PatientStore } from "@/Patient/Stores/PatientStore";

class PatientHistoryTaskHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalPatientOperations.History.Task_LoadPatientTask, this.LoadPatientTask);
        this.RegisterOperation(LocalPatientOperations.History.Task_SearchText, this.SearchText);
        this.RegisterOperation(LocalPatientOperations.History.Task_ShowSelectedTask, this.ShowSelectedTask);
        this.RegisterOperation(LocalPatientOperations.History.Task_CriteriaClick, this.CriteriaClick);
        this.RegisterOperation(LocalPatientOperations.History.Task_FromDateChanged, this.FromDateChanged);
        this.RegisterOperation(LocalPatientOperations.History.Task_ToDateChanged, this.ToDateChanged);
        this.RegisterOperation(LocalPatientOperations.History.Task_ToggleListDisplayMode, this.ToggleDisplayMode);
        this.RegisterOperation(LocalPatientOperations.History.Task_StatusChanged, this.StatusChanged);
        this.RegisterOperation(LocalPatientOperations.History.Task_ShowSelectedTaskFromRedirect, this.showSelectedTaskFromRedirect);
    }

    private FromDateChanged(request: LocalEvent, store: PatientStore): void {
        var taskModel = store.PatientHistoryTasksModels[request.PatientId];
        taskModel = taskModel.set("DateFrom", request.Get<Date>("value"));
        store.PatientHistoryTasksModels[request.PatientId] = taskModel;
        store.ActionsHistory.LoadPatientTask(request.PatientId, taskModel.get("SearchText"), taskModel.get("DateFrom"), taskModel.get("DateTo"));
    }

    private ToDateChanged(request: LocalEvent, store: PatientStore): void {
        var taskModel = store.PatientHistoryTasksModels[request.PatientId];
        taskModel = taskModel.set("DateTo", request.Get<Date>("value"));
        store.PatientHistoryTasksModels[request.PatientId] = taskModel;
        store.ActionsHistory.LoadPatientTask(request.PatientId, taskModel.get("SearchText"), taskModel.get("DateFrom"), taskModel.get("DateTo"));
    }

    public CriteriaClick(request: LocalEvent, store: PatientStore): void {
        var taskModel = store.PatientHistoryTasksModels[request.PatientId];
        var open = taskModel.get("IsCriteriaExpanded");
        taskModel = taskModel.set("IsCriteriaExpanded", !open);
        store.PatientHistoryTasksModels[request.PatientId] = taskModel;

        if (taskModel.get("IsCriteriaExpanded") === true)
            store.ActionsHistory.LoadPatientTask(request.PatientId, taskModel.get("SearchText"), taskModel.get("DateFrom"), taskModel.get("DateTo"));
        else
            store.ActionsHistory.LoadPatientTask(request.PatientId, taskModel.get("SearchText"), null, null);
    }

    private LoadPatientTask(request: LocalEvent, store: PatientStore): void {
        var taskModel = store.PatientHistoryTasksModels[request.PatientId];
        if (taskModel) {
            if (taskModel.get("IsCriteriaExpanded") === true)
                store.ActionsHistory.LoadPatientTask(request.PatientId, taskModel.get("SearchText"), taskModel.get("DateFrom"), taskModel.get("DateTo"));
            else
                store.ActionsHistory.LoadPatientTask(request.PatientId, taskModel.get("SearchText"), null, null);
        }
    }

    private SearchText(request: LocalEvent, store: PatientStore): void {
        var taskModel = store.PatientHistoryTasksModels[request.PatientId];
        var searchText = request.Get<string>("value");

        taskModel = taskModel.set("SearchText", searchText);
        store.PatientHistoryTasksModels[request.PatientId] = taskModel;

        if (taskModel.get("IsCriteriaExpanded") === true)
            store.ActionsHistory.LoadPatientTask(request.PatientId, taskModel.get("SearchText"), taskModel.get("DateFrom"), taskModel.get("DateTo"));
        else
            store.ActionsHistory.LoadPatientTask(request.PatientId, taskModel.get("SearchText"), null, null);
    }

    private ShowSelectedTask(request: LocalEvent, store: PatientStore): void {
        var task = request.Get<PatientTaskListItem>("task");

        var taskModel = store.PatientHistoryTasksModels[request.PatientId];

        taskModel = taskModel.set("ShowDetails", true);
        taskModel = taskModel.set("IM_ID", task.Model.IndividualMessageId);
        taskModel = taskModel.set("FromEmployee", task.Model.FromEmployee);
        taskModel = taskModel.set("Subject", task.Model.Subject);
        taskModel = taskModel.set("Body", task.Model.Body);
        taskModel = taskModel.set("ToEmployeeWithStatus", task.Model.ToEmployees);
        taskModel = taskModel.set("GenericTaskStatusId", task.GenericTaskStatusId);

        if (task.Model.StartDate) {
            var formattedStartDate = moment(task.Model.StartDate).format("YYYY/MM/DD") + " " + cacheStore.GetString("AtLabel") + " " + moment(task.Model.StartDate).format("HH:mm:ss");
            taskModel = taskModel.set("StartDate", formattedStartDate);
        }
        else
            taskModel = taskModel.set("StartDate", "");

        if (task.Model.DueDate) {
            var formattedDueDate = moment(task.Model.DueDate).format("YYYY/MM/DD") + " " + cacheStore.GetString("AtLabel") + " " + moment(task.Model.DueDate).format("HH:mm:ss");
            taskModel = taskModel.set("DueDate", formattedDueDate);
        }
        else
            taskModel = taskModel.set("DueDate", "");

        taskModel = taskModel.set("Priority", task.Model.Priority);
        taskModel = taskModel.set("Type", task.Model.Type);

        store.PatientHistoryTasksModels[request.PatientId] = taskModel;

        store.ActionsHistory.LoadMessageOrTaskNotes(task.Model.IndividualMessageId, SubServerOperations.PatientHistory.LoadTaskNotes);
    }

    private ToggleDisplayMode(request: LocalEvent, store: PatientStore): void {
        var taskModel = store.PatientHistoryTasksModels[request.PatientId];
        taskModel = taskModel.set("NotCompletedOnly", !taskModel.get("NotCompletedOnly"));
        store.PatientHistoryTasksModels[request.PatientId] = taskModel;
    }

    private StatusChanged(request: LocalEvent, store: PatientStore): void {
        var statusId = request.Get<string>("value");
        var TaskModel = store.PatientHistoryTasksModels[request.PatientId];

        store.ActionsHistory.SetTaskStatus(TaskModel.get("IM_ID"), statusId);
    }

    private showSelectedTaskFromRedirect(request: LocalEvent, store: PatientStore): void {
        store.ActionsHistory.loadSingleTask(request.Get<string>("taskId"));
    }
}

export { PatientHistoryTaskHandler };
